import { BrowserModule } from '@angular/platform-browser';
import { FundamentalChartModule } from '../fundamental-chart/fundamental-chart.module';
// Module imports
import { ConfigModule } from 'NewAngular/config/config.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class SimpleFundChartModule {
}
SimpleFundChartModule.ɵfac = function SimpleFundChartModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SimpleFundChartModule)(); };
SimpleFundChartModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: SimpleFundChartModule });
SimpleFundChartModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [BrowserModule, ConfigModule, TooltipModule, FundamentalChartModule] });
